// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {VOGSet} from "@models";
import {SimVOGSetService} from "@services";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-vog-chip-input",
	templateUrl: "./sim-vog-chip-input.component.html",
	styleUrls: ["./sim-vog-chip-input.component.scss"],
	standalone: false,
})
export class SimVogChipInputComponent {
	@Input() vogSetFc: FormArray<FormControl<VOGSet>>;
	@Input() label: string;
	@Input() placeholder: string;

	@Input() canSelectMultipleVogSets = false;

	optionSelected = output<VOGSet>();

	autoCompleteData: VMAutoCompleteNormal<VOGSet>[] = [];

	constructor(private _simVogSetService: SimVOGSetService) {}

	reloadAutoCompleteData(searchString: string) {
		this._simVogSetService.listVOGSets(searchString, "Name", true, 0, 20).then((vogSets) => {
			this.autoCompleteData = vogSets.data.map((v) => ({
				displayName: v.name,
				value: v,
			}));
		});
	}
}
